// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"2012c43d","lsc":"af23e989","others":"63872f09"}[chunkId] + ".chunk.js";
};